module.exports = __webpack_public_path__ + "img/09.8e8bb613.png";